module.exports = __webpack_public_path__ + "static/standard_map-e025135cafff0ccd1cfc2b3b8249e7e5.png";